import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.scss';
import Navbar from './components/navbar/Navbar';
import LandingPage from './pages/LandingPage/LandingPage';
import Login from './pages/login/Login';
import Register from './pages/register/Register';
import {onAuthStateChanged} from 'firebase/auth';
import { auth, firestore } from './firebase/firebaseConfig'
import { onSnapshot,doc } from 'firebase/firestore';
import { useDispatch, useSelector } from 'react-redux';
import { updateUser } from './redux/userReducer/userSlice';
import DetectLoader from './components/detectLoader/DetectLoader';
import Error from './components/errorComponent/Error';
import Note from './components/noteComponent/Note';
function App() {
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.user.currentUser);
  const loadingImg = useSelector(state => state.loader.isLoading);
  const Detection = React.lazy(()=> import("./pages/detection/Detection"))
  
  React.useEffect(()=> {
    let unSubscribeFromAuth = null;
    unSubscribeFromAuth = onAuthStateChanged( auth, async user => {
      if(user) {
      onSnapshot(doc(firestore,'users',`${user.uid}`), snapshot => {
       dispatch(updateUser({
          ...snapshot.data()
        }))
      })
      }
      else{
        dispatch(updateUser(null))
      }
    })
    return () => unSubscribeFromAuth();
  },[])

  
  return (
    <React.Suspense>
    <Navbar />
  <Error />
    {loadingImg ? <DetectLoader />:"" }   
    <Note />
    <Routes>
      <Route path='/' index element={<LandingPage/>} />
      <Route path='/register'  element={currentUser ?<Navigate to='/detection' replace />:<Register />} />
      <Route path='/login' element={currentUser ?<Navigate to='/detection' replace />:<Login />} />
      <Route path='/detection' element={currentUser ? <Detection/>:<Navigate to='/login' replace />} />
    </Routes>
    </React.Suspense>
  );
}

export default App;
